module.exports = __webpack_public_path__ + "img/tooltip.d0adbba6.svg";